<template>
  <div id="member-subscription-list">
    <v-dialog
      v-model="previewRecordPrompt"
      max-width="75%"
      transition="dialog-bottom-transition"
    >
      <efficiency-status-preview
        pageTitle="Efficiency Preview"
        pageDescription="Efficiency Preview"
        :previewRecordPrompt="previewRecordPrompt"
        @hidePreviewRecordPrompt="hidePreviewRecordPrompt"
        :recordData="selectedData"
        v-if="previewRecordPrompt"
      ></efficiency-status-preview>
    </v-dialog>

    <!-- Page Header -->
    <v-card class="page-header-card mb-6" elevation="0">
      <v-card-title class="page-title-wrapper">
        <div class="title-content">
          <v-icon color="primary" size="32" class="mr-3">mdi-chart-line</v-icon>
          <div>
            <h2 class="page-title">{{ PageTitle }}</h2>
            <p class="page-subtitle mb-0" v-if="PageDescription">
              {{ PageDescription }}
            </p>
          </div>
        </div>
      </v-card-title>
    </v-card>

    <!-- Search Form Card -->
    <v-card class="search-form-card mb-6" elevation="2">
      <v-card-title class="form-card-title">
        <v-icon color="primary" class="mr-2">mdi-filter-variant</v-icon>
        <span>Search Filters</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-6">
        <v-form ref="form2" v-model="valid1" lazy-validation>
          <v-container fluid>
            <!-- Filter Row 1 -->
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-if="RoleId == 1 || RoleId == 2 || RoleId == 4"
              >
                <div class="field-wrapper">
                  <label class="field-label">
                    <v-icon small color="error" class="mr-1"
                      >mdi-asterisk</v-icon
                    >
                    Year
                  </label>
                  <v-autocomplete
                    v-model="JciYearCode"
                    :items="JciYearCodeOptions"
                    :loading="JciYearCodeOptionsLoading"
                    :rules="JciYearCodeRules"
                    dense
                    clearable
                    required
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    hide-details="auto"
                  ></v-autocomplete>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <div class="field-wrapper">
                  <label class="field-label">
                    <v-icon small color="error" class="mr-1"
                      >mdi-asterisk</v-icon
                    >
                    Area
                  </label>
                  <v-autocomplete
                    @change="getZoneCodeOptions"
                    :reduce="(option) => option.value"
                    :loading="AreaCodeOptionsLoading"
                    :items="AreaCodeOptions"
                    :rules="AreaCodeRules"
                    v-model="AreaCode"
                    prepend-inner-icon="mdi-map-marker"
                    dense
                    clearable
                    required
                    outlined
                    hide-details="auto"
                    class="custom-input"
                  ></v-autocomplete>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <div class="field-wrapper">
                  <label class="field-label">
                    <v-icon small color="error" class="mr-1"
                      >mdi-asterisk</v-icon
                    >
                    Zone
                  </label>
                  <v-autocomplete
                    @change="getRegionCodeOptions"
                    :reduce="(option) => option.value"
                    :loading="ZoneCodeOptionsLoading"
                    :items="ZoneCodeOptions"
                    :rules="ZoneCodeRules"
                    v-model="ZoneCode"
                    prepend-inner-icon="mdi-view-grid"
                    dense
                    clearable
                    required
                    outlined
                    hide-details="auto"
                    class="custom-input"
                  ></v-autocomplete>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <div class="field-wrapper">
                  <label class="field-label">
                    Region
                    <span class="optional-label">(Optional)</span>
                  </label>
                  <v-autocomplete
                    @change="getLomCodeOptions"
                    :reduce="(option) => option.value"
                    :loading="RegionCodeOptionsLoading"
                    :items="RegionCodeOptions"
                    :rules="RegionCodeRules"
                    v-model="RegionCode"
                    prepend-inner-icon="mdi-map"
                    dense
                    clearable
                    outlined
                    hide-details="auto"
                    class="custom-input"
                  ></v-autocomplete>
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <div class="field-wrapper">
                  <label class="field-label">
                    LO
                    <span class="optional-label">(Optional)</span>
                  </label>
                  <v-autocomplete
                    :reduce="(option) => option.value"
                    :loading="LomCodeOptionsLoading"
                    :items="LomCodeOptions"
                    v-model="LomCode"
                    prepend-inner-icon="mdi-account-group"
                    dense
                    clearable
                    outlined
                    hide-details="auto"
                    class="custom-input"
                  ></v-autocomplete>
                </div>
              </v-col>
            </v-row>

            <!-- Filter Row 2 -->
            <v-row>
              <v-col cols="12">
                <div class="field-wrapper">
                  <label class="field-label">
                    100% Efficiency
                    <span class="optional-label">(Optional)</span>
                  </label>
                  <v-autocomplete
                    :reduce="(option) => option.value"
                    v-model="EfficiencyId"
                    :items="EfficiencyIdOptions"
                    :loading="EfficiencyIdOptionsLoading"
                    prepend-inner-icon="mdi-chart-arc"
                    dense
                    clearable
                    outlined
                    hide-details="auto"
                    class="custom-input"
                  ></v-autocomplete>
                </div>
              </v-col>
            </v-row>

            <!-- Action Buttons -->
            <v-row class="mt-2">
              <v-col cols="12">
                <v-divider class="mb-4"></v-divider>
                <div class="action-buttons-wrapper">
                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="searchForm"
                    :loading="SearchFlag"
                    color="primary"
                    large
                    elevation="2"
                    class="action-btn primary-btn text-white"
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    Search
                  </v-btn>

                  <v-btn
                    @click.prevent="GenerateExcelReport"
                    color="deep-purple accent-3"
                    large
                    elevation="2"
                    class="action-btn ml-3 text-white"
                  >
                    <v-icon left>mdi-file-excel</v-icon>
                    Generate Excel
                  </v-btn>

                  <v-btn
                    @click.prevent="GenerateGrowthReport"
                    color="cyan"
                    large
                    elevation="2"
                    class="action-btn ml-3 text-white"
                  >
                    <v-icon left>mdi-chart-timeline-variant</v-icon>
                    Growth Report
                  </v-btn>

                  <v-btn
                    v-if="ExcelFileName != '' && ExcelDownloadFlag"
                    :href="ExcelFileName"
                    target="_blank"
                    color="success"
                    large
                    elevation="2"
                    class="action-btn download-btn ml-3"
                  >
                    <v-icon left>mdi-download</v-icon>
                    Download Report
                  </v-btn>

                  <v-btn
                    v-if="GrowthExcelFileName != '' && GrowthExcelDownloadFlag"
                    :href="GrowthExcelFileName"
                    target="_blank"
                    color="success"
                    large
                    elevation="2"
                    class="action-btn download-btn ml-3"
                  >
                    <v-icon left>mdi-download</v-icon>
                    Download Growth
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Loading State Overlay -->
    <v-card
      v-if="LoadingFlag || StartupLoadingFlag"
      class="loading-overlay-card mb-6"
      elevation="2"
    >
      <v-card-text class="text-center py-10">
        <v-progress-circular
          indeterminate
          color="primary"
          size="60"
          width="6"
        ></v-progress-circular>
        <h3 class="mt-5 mb-2 primary--text">Processing your request...</h3>
        <p class="mb-0 grey--text text--darken-1">
          {{
            StartupLoadingFlag
              ? "Initializing data..."
              : "Please wait while we fetch the results"
          }}
        </p>
      </v-card-text>
    </v-card>

    <!-- No Records Message -->
    <v-card
      v-if="
        tableData1.length == 0 &&
        !StartupLoadingFlag &&
        !LoadingFlag &&
        !SearchFlag
      "
      class="no-records-card"
      elevation="1"
    >
      <v-card-text class="text-center py-12">
        <v-icon size="80" color="grey lighten-1">mdi-database-search</v-icon>
        <h3 class="mt-4 grey--text text--darken-1">No records found</h3>
        <p class="mb-0 grey--text">Try adjusting your search filters</p>
      </v-card-text>
    </v-card>

    <!-- Data Table Card -->
    <v-card v-if="tableData1.length > 0" class="data-table-card" elevation="2">
      <v-card-title class="table-card-title">
        <v-icon color="primary" class="mr-2">mdi-table</v-icon>
        <span>Efficiency Status Report</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search in results..."
          single-line
          hide-details
          outlined
          dense
          class="search-field"
          style="max-width: 350px"
        ></v-text-field>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-0">
        <v-data-table
          class="custom-data-table"
          v-model="selected"
          :search="search"
          :item-key="tableOptions1.ItemKey"
          :single-select="tableOptions1.SingleSelectFlag"
          :headers="tableColumns1"
          :items="tableData1"
          :items-per-page="tableOptions1.ItemsPerPage"
          :footer-props="tableOptions1.FooterProps"
        >
          <template v-slot:item.ActiveStatusTxt="{ item }">
            <v-chip
              :color="getActiveStatusColor(item.ActiveStatusTxt)"
              small
              label
              dark
            >
              {{ item.ActiveStatusTxt }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom v-if="item.PreviewFlag">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="primary"
                  @click="previewData(item)"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Preview Details</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import EfficiencyStatusPreview from "@/view/pages/erp/reports/LOEfficiencyStatusPreview.vue";

export default {
  mixins: [common],
  components: {
    EfficiencyStatusPreview,
  },
  data() {
    return {
      valid1: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      SearchFlag: false,

      previewRecordPrompt: false,

      DownloadFlag: false,
      ExcelFileName: "",
      ExcelFields: {},

      tableData1: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCode: "",
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      AreaCodeRules: [(v) => !!v || "Area is required"],
      AreaCode: "",
      AreaCodeOptions: [],
      AreaCodeOptionsLoading: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      RegionCodeRules: [],
      RegionCode: "",
      RegionCodeOptions: [],
      RegionCodeOptionsLoading: false,

      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      EfficiencyId: "",
      EfficiencyIdOptions: [],
      EfficiencyIdOptionsLoading: false,

      ExcelFileName: "",
      ExcelDownloadFlag: false,

      GrowthExcelFileName: "",
      GrowthExcelDownloadFlag: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      RoleId: "",
      FloatingButtonOptions: {},
    };
  },
  mounted() {},
  computed: {
    ActiveYearCode() {
      if (this.RoleId == 1 || this.RoleId == 2 || this.RoleId == 4) {
        return this.JciYearCode;
      } else {
        return this.CurrentYearId;
      }
    },
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        console.log({ RoleId: RoleId });
        this.RoleId = RoleId;

        this.JciYearCodeOptionsLoading = true;
        this.getYearCodeOptions();

        if (this.RoleId != 1 && this.RoleId != 2 && this.RoleId != 4) {
          this.getAreaCodeOptions();
        }
        this.getEfficiencyIdOptions();
      }
    },
    AreaCodeOptions: function () {
      console.log("watch AreaCodeOptions");
      this.AreaCodeOptionsLoading = false;
      this.LoadingFlag = false;
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.ZoneCodeOptionsLoading = false;
    },
    RegionCodeOptions: function () {
      console.log("watch RegionCodeOptions");
      this.RegionCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LomCodeOptionsLoading = false;
    },
    EfficiencyIdOptions: function () {
      console.log("watch EfficiencyIdOptions");
      this.LoadingFlag = false;
      this.EfficiencyIdOptionsLoading = false;
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
    JciYearCode: function () {
      console.log("watch JciYearCode");
      if (this.RoleId == 1 || this.RoleId == 2 || this.RoleId == 4) {
        this.getAreaCodeOptions();
      }
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    resetForm() {
      this.search = "";
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "efficiency_report",
        Action: "report_2",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    getEfficiencyIdOptions() {
      console.log("getEfficiencyIdOptions called");
      var yearCode = this.ActiveYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.LoadingFlag = true;
        this.EfficiencyIdOptionsLoading = true;
        var selectbox1_source = "EfficiencyId";
        var selectbox1_destination = "EfficiencyIdOptions";
        var selectbox1_url = "api/year-wise-efficiency/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          Year: yearCode,
          NotAvailable: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getYearCodeOptions() {
      console.log("getYearCodeOptions called");
      var CurrentYearId = this.JciYearCode;
      this.AreaCode = "";
      console.log("CurrentYearId=" + CurrentYearId);
      this.LoadingFlag = true;
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 3,
        where: [["jci_year_id", ">=", 15]],
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getAreaCodeOptions() {
      console.log("getAreaCodeOptions called");
      this.AreaCodeOptionsLoading = true;
      var YearCode = null;
      this.AreaCode = "";
      var selectbox1_source = "AreaCode";
      var selectbox1_destination = "AreaCodeOptions";
      var selectbox1_url = "api/year-wise-lom/area-options";
      if (this.RoleId != 1 && this.RoleId != 2 && this.RoleId != 4) {
        YearCode = this.CurrentYearId;
      } else {
        YearCode = this.JciYearCode;
      }
      var selectbox1_conditions_array = {
        UserInterface: 3,
        YearCode: YearCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      this.tableData1 = [];
      this.ZoneCode = "";
      this.RegionCode = "";
      this.LomCode = "";
      this.ZoneCodeOptions = [];
      this.RegionCodeOptions = [];
      this.LomCodeOptions = [];

      var yearCode = this.ActiveYearCode;
      var areaCode = this.AreaCode;
      console.log("yearCode=" + yearCode + ", areaCode=" + areaCode);
      if (yearCode != "" && areaCode != "") {
        this.ZoneCode = "";
        this.ZoneCodeOptionsLoading = true;
        this.tableData2 = [];
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 7,
          AreaCode: areaCode,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getRegionCodeOptions() {
      console.log("getRegionCodeOptions called");
      this.tableData1 = [];
      this.RegionCode = "";
      this.LomCode = "";
      this.RegionCodeOptions = [];
      this.LomCodeOptions = [];

      var YearCode = this.ActiveYearCode;
      var AreaCode = this.AreaCode;
      var ZoneCode = this.ZoneCode;
      console.log(
        "YearCode=" +
          YearCode +
          ", AreaCode=" +
          AreaCode +
          ", ZoneCode=" +
          ZoneCode
      );
      if (YearCode != "" && AreaCode != "" && ZoneCode != "") {
        this.RegionCode = "";
        this.RegionCodeOptionsLoading = true;
        this.tableData2 = [];
        var selectbox1_source = "RegionCode";
        var selectbox1_destination = "RegionCodeOptions";
        var selectbox1_url = "api/year-wise-lom/region-options";
        var selectbox1_conditions_array = {
          UserInterface: 3,
          YearCode: YearCode,
          AreaCode: AreaCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      this.tableData1 = [];
      this.LomCode = "";
      this.LomCodeOptions = [];

      var YearCode = this.ActiveYearCode;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      console.log(
        "YearCode=" +
          YearCode +
          ", ZoneCode=" +
          ZoneCode +
          ", RegionCode=" +
          RegionCode
      );
      if (YearCode != "" && ZoneCode != "" && RegionCode != "") {
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 4,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
          RegionCode: RegionCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        if (RegionCode == "") {
          message += "Region should not be empty. ";
        }
        this.alert = {
          flag: true,
          color: "error",
          message: message,
        };
      }
    },
    searchForm() {
      console.log("searchForm called");

      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      var YearCode = this.ActiveYearCode;
      var AreaCode = this.AreaCode;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      var LomCode = this.LomCode;
      var EfficiencyId = this.EfficiencyId;
      console.log(
        "YearCode=" +
          YearCode +
          ", AreaCode=" +
          AreaCode +
          ", ZoneCode=" +
          ZoneCode +
          ", RegionCode=" +
          RegionCode +
          ", LomCode=" +
          LomCode +
          ", EfficiencyId=" +
          EfficiencyId
      );

      if (validate1) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/reports/efficiency-status";
        var upload = {
          UserInterface: 1,
          Year: YearCode,
          Area: AreaCode,
          Zone: ZoneCode,
          Region: RegionCode,
          Lom: LomCode,
          Criteria: EfficiencyId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.SearchFlag = true;
        this.tableData1 = [];

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            var options = records.TableOptions;

            if (flag == 1) {
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableOptions1 = options;
              thisIns.tableData1 = records.TableData;

              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "LO should not be empty.";
        console.log("error=" + message);
      }
    },
    GenerateExcelReport() {
      console.log("GenerateExcelReport called");

      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      var YearCode = this.ActiveYearCode;
      var AreaCode = this.AreaCode;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      var LomCode = this.LomCode;
      var EfficiencyId = this.EfficiencyId;
      console.log(
        "YearCode=" +
          YearCode +
          ", AreaCode=" +
          AreaCode +
          ", ZoneCode=" +
          ZoneCode +
          ", RegionCode=" +
          RegionCode +
          ", LomCode=" +
          LomCode +
          ", EfficiencyId=" +
          EfficiencyId
      );

      var LomCode = this.LomCode;
      console.log("LomCode=" + LomCode);

      if (validate1) {
        this.ExcelFileName = "";
        this.ExcelDownloadFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/reports/generate-efficiency-report";
        var upload = {
          UserInterface: 2,
          Year: YearCode,
          Area: AreaCode,
          Zone: ZoneCode,
          Region: RegionCode,
          Lom: LomCode,
          Criteria: EfficiencyId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.ResultFlag = false;
        this.LoadingFlag = true;
        this.StartupLoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.ResultFlag = false;
            thisIns.LoadingFlag = false;
            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.ExcelFileName = records.ExcelFileName;
              thisIns.ExcelDownloadFlag = records.ExcelDownloadFlag;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.ResultFlag = false;
            thisIns.LoadingFlag = false;
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "LO should not be empty.";
        console.log("error=" + message);
      }
    },
    GenerateGrowthReport() {
      console.log("GenerateGrowthReport called");

      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      var YearCode = this.ActiveYearCode;
      var AreaCode = this.AreaCode;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      var LomCode = this.LomCode;
      var EfficiencyId = this.EfficiencyId;
      console.log(
        "YearCode=" +
          YearCode +
          ", AreaCode=" +
          AreaCode +
          ", ZoneCode=" +
          ZoneCode +
          ", RegionCode=" +
          RegionCode +
          ", LomCode=" +
          LomCode +
          ", EfficiencyId=" +
          EfficiencyId
      );

      if (validate1) {
        this.GrowthExcelFileName = "";
        this.GrowthExcelDownloadFlag = false;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/reports/generate-growth-report";
        var upload = {
          UserInterface: 1,
          Year: YearCode,
          AreaCode: AreaCode,
          ZoneCode: ZoneCode,
          RegionCode: RegionCode,
          LomCode: LomCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.ResultFlag = false;
        this.LoadingFlag = true;
        this.StartupLoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.ResultFlag = false;
            thisIns.LoadingFlag = false;
            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.GrowthExcelFileName = records.ExcelFileName;
              thisIns.GrowthExcelDownloadFlag = records.ExcelDownloadFlag;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.ResultFlag = false;
            thisIns.LoadingFlag = false;
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "LO should not be empty.";
        console.log("error=" + message);
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#member-subscription-list {
  background: #f5f7fa;
  min-height: 100vh;
  padding: 24px;

  // Page Header Card
  .page-header-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 16px !important;

    .page-title-wrapper {
      padding: 24px 32px;

      .title-content {
        display: flex;
        align-items: center;
        width: 100%;

        .v-icon {
          color: white !important;
        }

        .page-title {
          color: white;
          font-size: 28px;
          font-weight: 700;
          margin: 0;
          letter-spacing: 0.5px;
        }

        .page-subtitle {
          color: rgba(255, 255, 255, 0.9);
          font-size: 14px;
          margin-top: 4px;
        }
      }
    }
  }

  // Loading Card
  .loading-card {
    background: white;
    border-radius: 16px !important;
    border: 1px solid #e0e0e0;
  }

  // Loading Overlay Card
  .loading-overlay-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border-radius: 16px !important;
    border: 2px solid #667eea;
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.15) !important;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(102, 126, 234, 0.1),
        transparent
      );
      animation: shimmer 2s infinite;
    }

    .v-card__text {
      position: relative;
      z-index: 1;
    }
  }

  @keyframes shimmer {
    0% {
      left: -100%;
    }
    100% {
      left: 100%;
    }
  }

  // Search Form Card
  .search-form-card {
    background: white;
    border-radius: 16px !important;
    overflow: hidden;

    .form-card-title {
      background: linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%);
      padding: 20px 24px;
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      border-bottom: 2px solid #667eea;
    }

    .field-wrapper {
      margin-bottom: 8px;

      .field-label {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 8px;

        .v-icon {
          font-size: 12px;
        }

        .optional-label {
          color: #95a5a6;
          font-weight: 400;
          font-size: 12px;
          margin-left: 4px;
        }
      }

      .custom-input {
        .v-input__control {
          .v-input__slot {
            background: #fafbfc;
            border: 1px solid #e1e4e8;
            transition: all 0.3s ease;

            &:hover {
              background: white;
              border-color: #667eea;
            }
          }

          &.v-input--is-focused .v-input__slot {
            background: white;
            border-color: #667eea;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          }
        }
      }
    }

    .action-buttons-wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      justify-content: center;

      .action-btn {
        text-transform: none;
        font-weight: 600;
        letter-spacing: 0.5px;
        border-radius: 8px;
        padding: 0 24px !important;
        min-width: 160px;

        &.primary-btn {
          background: linear-gradient(
            135deg,
            #667eea 0%,
            #764ba2 100%
          ) !important;
        }

        &.download-btn {
          animation: pulse 2s infinite;
        }

        .v-icon {
          font-size: 20px;
        }
      }
    }
  }

  // No Records Card
  .no-records-card {
    background: white;
    border-radius: 16px !important;
    border: 2px dashed #e0e0e0;
  }

  // Data Table Card
  .data-table-card {
    background: white;
    border-radius: 16px !important;
    overflow: hidden;

    .table-card-title {
      background: linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%);
      padding: 20px 24px;
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      border-bottom: 2px solid #667eea;

      .search-field {
        .v-input__control {
          .v-input__slot {
            background: #fafbfc;
            border: 1px solid #e1e4e8;
            transition: all 0.3s ease;

            &:hover {
              background: white;
              border-color: #667eea;
            }
          }
        }
      }
    }

    .custom-data-table {
      // Table Headers
      .v-data-table-header {
        background: linear-gradient(180deg, #f8f9fa 0%, #f1f3f5 100%);

        th {
          font-size: 14px !important;
          font-weight: 700 !important;
          color: #2c3e50 !important;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 2px solid #667eea !important;
          padding: 16px !important;
          white-space: nowrap;
        }
      }

      // Table Body
      tbody {
        tr {
          transition: all 0.2s ease;

          &:hover {
            background: linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%);
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          }

          td {
            font-size: 14px !important;
            color: #34495e;
            padding: 16px !important;
            border-bottom: 1px solid #f1f3f5 !important;
          }
        }
      }

      // Chips
      .v-chip {
        font-weight: 600;
        font-size: 12px;
        letter-spacing: 0.5px;
        border-radius: 6px;
        padding: 0 12px;
        height: 28px;
      }

      // Footer
      .v-data-footer {
        background: #f8f9fa;
        border-top: 2px solid #e1e4e8;
        padding: 12px 16px;

        .v-data-footer__select,
        .v-data-footer__pagination {
          font-size: 13px;
          color: #2c3e50;
        }
      }
    }
  }

  // Floating Action Button
  .v-btn--floating {
    position: relative;
  }

  .v-speed-dial--bottom {
    bottom: 12%;
  }

  .v-speed-dial--right {
    right: 5%;
  }

  // Animation for download buttons
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(46, 182, 90, 0.7);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(46, 182, 90, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(46, 182, 90, 0);
    }
  }

  // Responsive adjustments
  @media (max-width: 960px) {
    padding: 16px;

    .page-header-card .page-title-wrapper {
      padding: 20px;

      .page-title {
        font-size: 22px;
      }
    }

    .action-buttons-wrapper {
      .action-btn {
        width: 100%;
        margin: 0 0 8px 0 !important;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 12px;

    .page-header-card .page-title-wrapper {
      padding: 16px;

      .title-content {
        flex-direction: column;
        text-align: center;

        .v-icon {
          margin-bottom: 8px;
        }
      }

      .page-title {
        font-size: 20px;
      }
    }
  }
}
</style>